import { SVGProps } from "react";

export function Wallet({ className }: SVGProps<SVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_519_19319)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.7403 3.21493L8.06332 1.29639L9.17378 3.21974L4.7403 3.21493Z"
          stroke="currentColor"
          strokeWidth="0.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.37408 3.70416C1.37408 3.43823 1.58966 3.22266 1.85559 3.22266H10.5227C10.7887 3.22266 11.0042 3.43823 11.0042 3.70416V10.4453C11.0042 10.7112 10.7887 10.9268 10.5227 10.9268H1.85559C1.58966 10.9268 1.37408 10.7112 1.37408 10.4453V3.70416Z"
          fill="curentColor"
          stroke="currentColor"
          strokeWidth="0.5"
          strokeLinejoin="round"
        />
        <path
          d="M8.89762 8.27814H11.0042V5.87061H8.89762C8.19956 5.87061 7.63367 6.40956 7.63367 7.07437C7.63367 7.73919 8.19956 8.27814 8.89762 8.27814Z"
          fill="white"
          stroke="white"
          strokeWidth="0.5"
          strokeLinejoin="round"
        />
        <path
          d="M11.0042 4.30615V10.0842"
          stroke="currentColor"
          strokeWidth="0.5"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_519_19319">
          <rect
            width="11.5562"
            height="11.5562"
            fill="white"
            transform="translate(0.411072 0.333496)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
